import { useEffect } from 'react';
import heroImg from '../../assets/imgs/home/gallery/16.jpg';
import Constants from '../../utils/Constants';

const contactPattern =
  /(https?:\/\/[^\s|]+|www\.[^\s|]+|[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}|\+385\s*\(0\)\s*\d(?:[\s-]*\d){6,})/gi;

const renderWithLinks = (text: string) =>
  text.split(contactPattern).map((part, index) => {
    if (!part) return null;

    if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(part)) {
      return (
        <a className='privacy_link' href={`mailto:${part}`} key={index}>
          {part}
        </a>
      );
    }

    if (/^\+385/.test(part)) {
      const phoneNumber = part.replace('(0)', '').replace(/[^\d+]/g, '');

      return (
        <a className='privacy_link' href={`tel:${phoneNumber}`} key={index}>
          {part}
        </a>
      );
    }

    if (/^(https?:\/\/|www\.)/i.test(part)) {
      const href = part.startsWith('www.') ? `https://${part}` : part;

      return (
        <a
          className='privacy_link'
          href={href}
          key={index}
          rel='noreferrer'
          target='_blank'
        >
          {part}
        </a>
      );
    }

    return part;
  });

const PrivacyPolicy = ({ lang }: { lang: Locale.Keys }) => {
  const content = lang.privacyPolicy;

  useEffect(() => {
    document.title = `Cora - ${content.title}`;
  }, [content.title]);

  return (
    <div id={Constants.PRIVACY_POLICY} className='privacy'>
      <div className='privacy_hero'>
        <img src={heroImg} alt={`${content.title} hero`} />
      </div>
      <main className='privacy_container container'>
        <h1>{content.title}</h1>

        <section className='privacy_container_section'>
          <h2>{content.introduction.title}</h2>
          <p>{renderWithLinks(content.introduction.text)}</p>
        </section>

        {content.sections.map((section) => (
          <section className='privacy_container_section' key={section.title}>
            <h2>{section.title}</h2>
            {section.blocks.map((block, blockIndex) => {
              if (block.type === 'paragraph') {
                return (
                  <p key={blockIndex}>
                    {block.text && renderWithLinks(block.text)}
                  </p>
                );
              }

              return (
                <ul key={blockIndex}>
                  {block.items?.map((item) => (
                    <li key={item.text}>
                      {renderWithLinks(item.text)}
                      {item.details?.map((detail) => (
                        <span className='privacy_contact_line' key={detail}>
                          {renderWithLinks(detail)}
                        </span>
                      ))}
                    </li>
                  ))}
                </ul>
              );
            })}
          </section>
        ))}
      </main>
    </div>
  );
};

export default PrivacyPolicy;
